import GameState from "./GameState";

function Reset({gameState, onReset}) {
    if (gameState === GameState.inProcess) {
        return;
    }
    return <button onClick={onReset} className="reset-button">Reset</button>;
}

export default Reset;